<template>
<div class="chapter">
<div class="inner_page">
<p class="block_" id="id_Hlk61959347"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_1" lang="en">About the Author</h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_2"><span lang="en">David Moore was born in Ireland and later emigrated to Montreal. Moore published his first collection of poetry, </span><i class="calibre1" lang="en">Silence</i><span lang="en">, in 2016. Other books followed: </span><i class="calibre1" lang="en">Poems 2020, The March of the Copylong Shadows, 2020, Fame and Fortune, The Copyright Curse of Cassandra, 2021, The Life of a Slave, 2022,</i><span lang="en"> and </span><i class="calibre1" lang="en">The Timeless Love of Billy B for Scheherazade, 2022</i><span lang="en">. </span><i class="calibre1" lang="en">Evening Light over Kouraki</i><span lang="en"> is his first novel. He is presently working on another full-length novel, </span><i class="calibre1" lang="en">Things Not Said</i><span lang="en">. Moore has already made his mark as a visual artist in Canada, the USA, and Europe. <br class="calibre2" id="calibre_pb_0"/>
</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?046da1a7